<template>
    <div>
      <div v-if="checkIfSalesBillOfMaterial(task,'orderItems')">
        <div class="bg-grey shadow-md rounded p-4 border border-white mb-4" 
        v-if="
              (toLowerTitle(task.orderItems[0]) ||
                toLowerArticleNumber(task.orderItems[0]) ||
                toLowerTask(task)) == true || search === ''
            "
        :class="{
              'bg-gray-200 border-gray-200 ':
                checkDate(task.createdDate) === true,
            }">
          <div v-if="shown">
              <div v-if="task.orderItems[0].local_article.length">
                <div v-for="article in task.orderItems[0].local_article" :key="article.id">
                  <template v-if="article.media.length">
                    <template v-for="(media, j) in article.media">
                      <img
                        v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                      <img
                        v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                    </template>
                  </template>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="w-full object-contain my-3 h-56"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="w-full object-contain my-3 h-56"
                  />
                </div>
              </div>
              <img
                v-else-if="defaultArticleImage"
                :src="'/storage/' + defaultArticleImage"
                alt="default-article-img"
                class="w-full object-contain my-3 h-56"
              />
              <img
                v-else
                src="/img/dummyimg.jpg"
                alt="dummy-img"
                class="w-full object-contain my-3 h-56"
              />
          </div>
           <div class="xl:flex xl:flex-wrap xl:justify-between xl:items-center">
              <h2
                class="text-sm lg:text-base headline cursor-pointer"
                @click="toggleOrderModal(task, task.orderItems[0].id,task.orderItems[0],'sales_bill')"
                v-if="task.orderItems[0].title"
              >
                {{ task.orderItems[0].title }}
              </h2>
              <h2 v-else>N/A</h2>
              <h3 class="mt-3 xl:mt-0">
                <p class="flex flex-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                    />
                  </svg>
                  #{{ task.orderNumber }}
                </p>
                <p class="flex flex-wrap" v-if="checkItem(task.orderNumber) > 0">
                  <svg
                    @click="searchValue(task.orderNumber)"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 block cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                    />
                  </svg>
                  {{ checkItem(task.orderNumber) }}
                </p>
              </h3>
            </div>
            <p class="my-2">{{ task.orderItems[0].articleNumber }}</p>
            <badge v-if="task.status" :color="badgeColor">
              {{ ___("Status|" + task.status + "|content") }}
            </badge>
            <div class="flex justify-between items-center flex-wrap mt-3">
              <div v-if="task.orderItems[0].local_article.length > 0">
                <div
                  v-for="article in task.orderItems[0].local_article"
                  :key="article.id"
                  class="flex"
                >
                  <div
                    v-if="article.weclapp_stock + article.new_stock > 10"
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|available|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      article.weclapp_stock + article.new_stock <= 10 &&
                      article.weclapp_stock + article.new_stock > 0
                    "
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|Less than 10 in stock|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                  <div
                    v-else-if="article.weclapp_stock + article.new_stock <= 0"
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#f1c40f"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|Will arrive at expected date|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="invisible w-6 h-5 mr-1">No data</div>
              <div
                v-if="task.orderItems[0].plannedShippingDate"
                class="inline-flex items-center relative group cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <span v-if="task.orderItems[0].newItemPlannedShippingDate">{{
                  formatDate(task.orderItems[0].newItemPlannedShippingDate)
                }}</span>
                <span v-else>{{ formatDate(task.orderItems[0].plannedShippingDate) }}</span>
                <div
                  class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-xs
                      leading-none
                      text-white
                      whitespace-no-wrap
                      bg-black
                      shadow-lg
                    "
                  >
                    {{ ___("General|Expected Shipment Date|content") }}
                  </span>
                  <div
                    class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                  ></div>
                </div>
              </div>
              <div v-else class="inline-flex items-center text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {{ ___("Pipeline|Date confirmation pending|content") }}
              </div>

              <div class="flex">
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#48bb78"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>

                  <span v-if="task.orderItems[0].requested_qty">
                    {{
                      Number(task.orderItems[0].quantity) -
                      (Number(task.orderItems[0].requested_qty) + Number(task.orderItems[0].shippedQuantity))
                    }}
                  </span>
                  <span v-else>{{
                    Number(task.orderItems[0].quantity) - Number(task.orderItems[0].shippedQuantity)
                  }}</span>

                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{
                        ___("General|Available quantity for shipping|content")
                      }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#e14242"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span>{{ task.orderItems[0].shippedQuantity }}</span>

                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{ ___("General|Shipped quantity|content") }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                    />
                  </svg>
                  <span>{{ task.orderItems[0].quantity }}</span>
                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{ ___("General|Total order quantity|content") }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
              </div>

              <button
                aria-label="Open Detail modal"
                type="button"
                @click="toggleOrderModal(task, task.orderItems[0].id,task.orderItems[0],'sales_bill')"
                class="rounded-full outline-none focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="20"
                  height="20"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#000000">
                      <path
                        d="M86,14.33333c-39.49552,0 -71.66667,32.17115 -71.66667,71.66667c0,39.49552 32.17115,71.66667 71.66667,71.66667c39.49552,0 71.66667,-32.17115 71.66667,-71.66667c0,-39.49552 -32.17115,-71.66667 -71.66667,-71.66667zM86,28.66667c31.74921,0 57.33333,25.58412 57.33333,57.33333c0,31.74921 -25.58412,57.33333 -57.33333,57.33333c-31.74921,0 -57.33333,-25.58412 -57.33333,-57.33333c0,-31.74921 25.58412,-57.33333 57.33333,-57.33333zM78.83333,50.16667v14.33333h14.33333v-14.33333zM78.83333,78.83333v43h14.33333v-43z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </button>
            </div>

        </div>
      </div>
      <div v-else>
        <div v-for="(item, j) in task.orderItems" :key="j">
          <div
            v-if="
              (toLowerTitle(item) ||
                toLowerArticleNumber(item) ||
                toLowerTask(task)) == true || search === ''
            "
            class="bg-grey shadow-md rounded p-4 border border-white mb-4"
            :class="{
              'bg-gray-200 border-gray-200 ':
                checkDate(task.createdDate) === true,
            }"
          >
            <div v-if="shown">
              <div v-if="item.local_article.length">
                <div v-for="article in item.local_article" :key="article.id">
                  <template v-if="article.media.length">
                    <template v-for="(media, j) in article.media">
                      <img
                        v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                      <img
                        v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                    </template>
                  </template>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="w-full object-contain my-3 h-56"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="w-full object-contain my-3 h-56"
                  />
                </div>
              </div>
              <img
                v-else-if="defaultArticleImage"
                :src="'/storage/' + defaultArticleImage"
                alt="default-article-img"
                class="w-full object-contain my-3 h-56"
              />
              <img
                v-else
                src="/img/dummyimg.jpg"
                alt="dummy-img"
                class="w-full object-contain my-3 h-56"
              />
            </div>
            <div class="xl:flex xl:flex-wrap xl:justify-between xl:items-center">
              <h2
                class="text-sm lg:text-base headline cursor-pointer"
                @click="toggleOrderModal(task, item.id,item,'normal')"
                v-if="item.title"
              >
                {{ item.title }}
              </h2>
              <h2 v-else>N/A</h2>
              <h3 class="mt-3 xl:mt-0">
                <p class="flex flex-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                    />
                  </svg>
                  #{{ task.orderNumber }}
                </p>
                <p class="flex flex-wrap" v-if="checkItem(task.orderNumber) > 0">
                  <svg
                    @click="searchValue(task.orderNumber)"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 block cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                    />
                  </svg>
                  {{ checkItem(task.orderNumber) }}
                </p>
              </h3>
            </div>
            <p class="my-2">{{ item.articleNumber }}</p>
            <badge v-if="task.status" :color="badgeColor">
              {{ ___("Status|" + task.status + "|content") }}</badge
            >
            <div class="flex justify-between items-center flex-wrap mt-3">
              <div v-if="item.local_article.length > 0">
                <div
                  v-for="article in item.local_article"
                  :key="article.id"
                  class="flex"
                >
                  <div
                    v-if="article.weclapp_stock + article.new_stock > 10"
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|available|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      article.weclapp_stock + article.new_stock <= 10 &&
                      article.weclapp_stock + article.new_stock > 0
                    "
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|Less than 10 in stock|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                  <div
                    v-else-if="article.weclapp_stock + article.new_stock <= 0"
                    class="relative group cursor-pointer inline-flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#f1c40f"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div
                      class="
                        absolute
                        bottom-0
                        hidden
                        mb-6
                        group-hover:flex
                        flex-col
                      "
                    >
                      <span
                        class="
                          relative
                          z-10
                          p-2
                          text-xs
                          leading-none
                          text-white
                          whitespace-no-wrap
                          bg-black
                          shadow-lg
                        "
                      >
                        {{ ___("General|Will arrive at expected date|content") }}
                      </span>
                      <div
                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="invisible w-6 h-5 mr-1">No data</div>
              <div
                v-if="item.plannedShippingDate"
                class="inline-flex items-center relative group cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <span v-if="item.newItemPlannedShippingDate">{{
                  formatDate(item.newItemPlannedShippingDate)
                }}</span>
                <span v-else>{{ formatDate(item.plannedShippingDate) }}</span>
                <div
                  class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-xs
                      leading-none
                      text-white
                      whitespace-no-wrap
                      bg-black
                      shadow-lg
                    "
                  >
                    {{ ___("General|Expected Shipment Date|content") }}
                  </span>
                  <div
                    class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                  ></div>
                </div>
              </div>
              <div v-else class="inline-flex items-center text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {{ ___("Pipeline|Date confirmation pending|content") }}
              </div>

              <div class="flex">
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#48bb78"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>

                  <span v-if="item.requested_qty">
                    {{
                      Number(item.quantity) -
                      (Number(item.requested_qty) + Number(item.shippedQuantity))
                    }}
                  </span>
                  <span v-else>{{
                    Number(item.quantity) - Number(item.shippedQuantity)
                  }}</span>

                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{
                        ___("General|Available quantity for shipping|content")
                      }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#e14242"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span>{{ item.shippedQuantity }}</span>

                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{ ___("General|Shipped quantity|content") }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
                <div class="relative group cursor-pointer flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                    />
                  </svg>
                  <span>{{ item.quantity }}</span>
                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                      >{{ ___("General|Total order quantity|content") }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
              </div>

              <button
                aria-label="Open Detail modal"
                type="button"
                @click="toggleOrderModal(task, item.id,item,'normal')"
                class="rounded-full outline-none focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="20"
                  height="20"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#000000">
                      <path
                        d="M86,14.33333c-39.49552,0 -71.66667,32.17115 -71.66667,71.66667c0,39.49552 32.17115,71.66667 71.66667,71.66667c39.49552,0 71.66667,-32.17115 71.66667,-71.66667c0,-39.49552 -32.17115,-71.66667 -71.66667,-71.66667zM86,28.66667c31.74921,0 57.33333,25.58412 57.33333,57.33333c0,31.74921 -25.58412,57.33333 -57.33333,57.33333c-31.74921,0 -57.33333,-25.58412 -57.33333,-57.33333c0,-31.74921 25.58412,-57.33333 57.33333,-57.33333zM78.83333,50.16667v14.33333h14.33333v-14.33333zM78.83333,78.83333v43h14.33333v-43z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </button>
            </div>

            <div v-for="article in item.local_article" :key="article.id">
              <div
                v-if="
                  article.weclapp_stock + article.new_stock > 10 &&
                  article.discounted_article == true &&
                  task.status === 'ORDER_CONFIRMATION_PRINTED'
                "
                class="block xl:flex xl:justify-between items-center mt-3"
              >
                <div v-if="calculateQuantity(item) != 0">
                  <input
                    type="checkbox"
                    :id="item.articleId"
                    :checked="isSelected(item)"
                    @change="passEvent(item.id,item.articleId,article.article_name,task.id, task.orderNumber,$event.target.checked)"
                  />
                  <label :for="item.articleId">
                    {{ ___("Pipeline|Select bike for shipment|content") }}</label
                  >
                </div>
                <div v-if="selectedBikes.some(obj => obj.articleId === item.articleId && obj.orderId === task.id && obj.orderItemId === item.id )">
                  <div
                    class="
                      md:ml-4
                      flex flex-row
                      border
                      h-10
                      w-24
                      rounded-lg
                      border-gray-400
                      relative
                    "
                  >
                    <button
                      type="button"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-primary-text-color hover:text-primary-color
                        h-full
                        w-20
                        flex
                        rounded-l
                        focus:outline-none
                        cursor-pointer
                      "
                      @click="
                        decreasequantity(
                          item,
                          task.id,
                          task.orderNumber
                        )
                      "
                    >
                      <span class="m-auto">-</span>
                    </button>
                    <input
                      type="hidden"
                      class="
                        md:p-2
                        p-1
                        text-xs
                        md:text-base
                        border-gray-400
                        focus:outline-none
                        text-center
                      "
                      v-model="item.quantity"
                      name="custom-input-number"
                      min="1"
                    />
                    <p
                      class="
                        bg-white
                        w-24
                        text-xs
                        md:text-base
                        flex
                        items-center
                        justify-center
                        cursor-default
                      "
                    >
                    {{ selectedBikes.find(obj => obj.articleId === item.articleId && obj.orderId === task.id && obj.orderItemId === item.id).shipableItem }}
                    </p>

                    <button
                      type="button"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-primary-text-color hover:text-primary-color
                        h-full
                        w-20
                        flex
                        rounded-r
                        focus:outline-none
                        cursor-pointer
                      "
                      @click="
                        incrementquantity(
                          item,
                          task.id,
                          task.orderNumber
                        )
                      "
                    >
                      <span class="m-auto">+</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal v-if="orderModalShown" @close="toggleOrderModal" :data="modalData">
      <template v-slot:header>
        <h3 class="text-subheader-font-size font-semibold">
          {{ ___("General|PositionHeader|content") }}
        </h3>
      </template>

      <template v-slot:body>
        <div v-if="salesType == 'normal'">
          <div v-for="(item, k) in modalData.orderItems" :key="k">
          <div
            v-if="item.id == itemid"
            class="border-b border-solid border-gray-300"
          >
            <div class="md:flex md:justify-between mb-3">
              <h1 class="headline">{{ item.title }}</h1>
              <h2>{{ item.articleNumber }}</h2>
            </div>
            <div
              v-if="item.newItemPlannedShippingDate"
              class="relative group cursor-pointer flex items-center"
            >
              <span class="font-bold"
                >{{
                  ___("General|Expected Position Shipment Date|content")
                }}:</span
              >

              {{ formatDate(item.newItemPlannedShippingDate) }}
              {{
                formatDate(
                  item.plannedShippingDate,
                  item.newItemPlannedShippingDate
                )
              }}

              <div
                class="
                  absolute
                  bottom-0
                  left-0
                  hidden
                  mb-6
                  group-hover:flex
                  flex-col
                  items-end
                "
              >
                <span
                  class="
                    relative
                    z-10
                    p-2
                    text-xs
                    leading-none
                    text-white
                    whitespace-no-wrap
                    bg-black
                    shadow-lg
                  "
                  >{{ modalData.blockerReason }}</span
                >
                <div
                  class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                ></div>
              </div>
            </div>
            <p v-else>
              <span class="font-bold"
                >{{ ___("General|Expected Shipment Date|content") }}:</span
              >
              {{ formatDate(item.plannedShippingDate) }}
            </p>

            <div class="lg:flex lg:items-center">
              <div v-if="item.local_article.length" class="flex-none">
                <div v-for="article in item.local_article" :key="article.id">
                  <template v-if="article.media.length">
                    <template v-for="(media, j) in article.media">
                      <img
                        v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                        class="inline h-24 object-contain my-3"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                      <img
                        v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                        class="inline h-24 object-contain my-3"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                    </template>
                  </template>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="inline lg:h-24 object-contain my-3"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="inline lg:h-24 object-contain my-3"
                  />
                </div>
              </div>
              <img
                v-else-if="defaultArticleImage"
                :src="'/storage/' + defaultArticleImage"
                alt="default-article-img"
                class="inline lg:h-24 object-contain my-3 flex-none"
              />
              <img
                v-else
                src="/img/dummyimg.jpg"
                alt="dummy-img"
                class="inline lg:h-24 object-contain my-3 flex-none"
              />

              <div class="pl-4">
                <p class="font-bold" v-html="item.description"></p>
                <p>
                  {{ ___("Pipeline|Quantity|content") }}: {{ item.quantity }}
                </p>
                <div v-for="article in item.local_article" :key="article.id">
                  <p
                    class="inline-flex break-words items-center text-sm"
                    v-if="article.weclapp_stock + article.new_stock > 10"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|available|content") }}
                  </p>
                  <p
                    class="inline-flex break-words items-center text-sm"
                    v-else-if="
                      article.weclapp_stock + article.new_stock <= 10 &&
                      article.weclapp_stock + article.new_stock > 0
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|Less than 10 in stock|content") }}
                  </p>
                  <p
                    class="
                      inline-flex
                      leading-4
                      items-start
                      break-words
                      text-sm
                    "
                    v-else-if="article.weclapp_stock + article.new_stock <= 0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#f1c40f"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|Will arrive at expected date|content") }}
                  </p>
                </div>

                <p v-if="item.plannedShipmentDate">
                  {{ ___("Pipeline|Blocker Date|content") }}:
                  <span v-if="article.setblocker == true">
                    <span
                      v-html="
                        formatDate(item.plannedShipmentDate, article.blocker)
                      "
                    ></span>
                  </span>
                  <span v-else>
                    <span v-html="formatDate(item.plannedShipmentDate)"></span>
                  </span>
                </p>
              </div>
            </div>
          </div>
          </div>

        <div v-if="modalData.orderItems" class="mt-3">
          <h4 class="py-2 headline">
            {{ ___("Orders|Related Order Details|content") }}
          </h4>
          <p>
            {{ ___("Orders|Order number|content") }}:
            <span v-if="modalData.status == 'ORDER_ENTRY_IN_PROGRESS'">
              {{ ___("Pipeline|Order acceptance pending|content") }}
            </span>
            <span v-else>
              {{ modalData.orderNumber }}
            </span>
          </p>

          <p v-if="modalData.orderNumberAtCustomer">
            {{ ___("Orders|Order number at Customer|content") }}:
            {{ modalData.orderNumberAtCustomer }}
          </p>

          <div class="font-bold flex" v-if="!hideExpectedDates">
            {{ ___("General|Expected Order Completion Date|content") }}:
            <span>{{ formatDate(modalData.plannedShippingDate) }}</span>
          </div>

          <p v-if="item.grossAmount && $page.props.user.show_article_prices && $page.props.user.show_order_view">
            {{ ___("General|Amount|content") }}:
            {{ formatCurrency(item.grossAmount) }}
          </p>

          <div
            class="
              block
              md:flex
              items-center
              bg-primary-color
              text-primary-text-color text-sm
              font-bold
              px-4
              py-3
              my-3
            "
            v-if="modalData.status == 'ORDER_ENTRY_IN_PROGRESS'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p>
              {{ ___("General|NewOrders|content", { team: teamName }) }}
            </p>
          </div>

          <div v-else>
            <a
            v-if="$page.props.user.show_order_view && $page.props.user.show_article_prices"
            :href="'openorderpdf/' + modalData.id"
            target="_blank"
            class="
              inline-block
              mt-2
              bg-primary-color
              text-primary-text-color
              border border-primary-color
              hover:bg-primary-text-color hover:text-primary-color
              font-bold
              uppercase
              text-sm
              py-2
              px-4
              rounded-full
              outline-none
              focus:outline-none
            "
          >
            {{ ___("Pipeline|OrderDetail|content") }}
          </a>
          </div>


        </div>
        </div>
        <div v-else>
          <div
            v-if="modalData.orderItems[0].id == itemid"
            class="border-b border-solid border-gray-300"
          >
            <div class="md:flex md:justify-between mb-3">
              <h1 class="headline">{{ modalData.orderItems[0].title }}</h1>
              <h2>{{ modalData.orderItems[0].articleNumber }}</h2>
            </div>
            <div
              v-if="modalData.orderItems[0].newItemPlannedShippingDate"
              class="relative group cursor-pointer flex items-center"
            >
              <span class="font-bold"
                >{{
                  ___("General|Expected Position Shipment Date|content")
                }}:</span
              >

              {{ formatDate(modalData.orderItems[0].newItemPlannedShippingDate) }}
              {{
                formatDate(
                  modalData.orderItems[0].plannedShippingDate,
                  modalData.orderItems[0].newItemPlannedShippingDate
                )
              }}

              <div
                class="
                  absolute
                  bottom-0
                  left-0
                  hidden
                  mb-6
                  group-hover:flex
                  flex-col
                  items-end
                "
              >
                <span
                  class="
                    relative
                    z-10
                    p-2
                    text-xs
                    leading-none
                    text-white
                    whitespace-no-wrap
                    bg-black
                    shadow-lg
                  "
                  >{{ modalData.blockerReason }}</span
                >
                <div
                  class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                ></div>
              </div>
            </div>
            <p v-else>
              <span class="font-bold"
                >{{ ___("General|Expected Shipment Date|content") }}:</span
              >
              {{ formatDate(modalData.orderItems[0].plannedShippingDate) }}
            </p>

            <div class="lg:flex lg:items-center">
              <div v-if="modalData.orderItems[0].local_article.length" class="flex-none">
                <div v-for="article in modalData.orderItems[0].local_article" :key="article.id">
                  <div v-if="article.media.length">
                    <div v-for="(media, j) in article.media" :key="j">
                      <img
                        v-if="media.collection_name == 'main'"
                        class="inline h-24 object-contain my-3"
                        v-bind:src="
                          '/storage/' + media.id + '/' + media.file_name
                        "
                        v-bind:alt="media.name"
                      />
                    </div>
                  </div>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="inline lg:h-24 object-contain my-3"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="inline lg:h-24 object-contain my-3"
                  />
                </div>
              </div>
              <img
                v-else-if="defaultArticleImage"
                :src="'/storage/' + defaultArticleImage"
                alt="default-article-img"
                class="inline lg:h-24 object-contain my-3 flex-none"
              />
              <img
                v-else
                src="/img/dummyimg.jpg"
                alt="dummy-img"
                class="inline lg:h-24 object-contain my-3 flex-none"
              />

              <div class="pl-4">
                <p class="font-bold" v-html="modalData.orderItems[0].description"></p>
                <p>
                  {{ ___("Pipeline|Quantity|content") }}: {{ modalData.orderItems[0].quantity }}
                </p>
                <div v-for="article in modalData.orderItems[0].local_article" :key="article.id">
                  <p
                    class="inline-flex break-words items-center text-sm"
                    v-if="article.weclapp_stock + article.new_stock > 10"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|available|content") }}
                  </p>
                  <p
                    class="inline-flex break-words items-center text-sm"
                    v-else-if="
                      article.weclapp_stock + article.new_stock <= 10 &&
                      article.weclapp_stock + article.new_stock > 0
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#68d391"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|Less than 10 in stock|content") }}
                  </p>
                  <p
                    class="
                      inline-flex
                      leading-4
                      items-start
                      break-words
                      text-sm
                    "
                    v-else-if="article.weclapp_stock + article.new_stock <= 0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#f1c40f"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {{ ___("General|Will arrive at expected date|content") }}
                  </p>
                </div>

                <p v-if="modalData.orderItems[0].plannedShipmentDate">
                  {{ ___("Pipeline|Blocker Date|content") }}:
                  <span v-if="article.setblocker == true">
                    <span
                      v-html="
                        formatDate(modalData.orderItems[0].plannedShipmentDate, article.blocker)
                      "
                    ></span>
                  </span>
                  <span v-else>
                    <span v-html="formatDate(modalData.orderItems[0].plannedShipmentDate)"></span>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div v-if="modalData.orderItems" class="mt-3">
            <h4 class="py-2 headline">
                {{ ___("Orders|Related Order Details|content") }}
            </h4>
            <p>
                {{ ___("Orders|Order number|content") }}:
                <span v-if="modalData.status == 'ORDER_ENTRY_IN_PROGRESS'">
                {{ ___("Pipeline|Order acceptance pending|content") }}
                </span>
                <span v-else>
                {{ modalData.orderNumber }}
                </span>
            </p>

            <p v-if="modalData.orderNumberAtCustomer">
                {{ ___("Orders|Order number at Customer|content") }}:
                {{ modalData.orderNumberAtCustomer }}
            </p>

            <div class="font-bold flex">
                {{ ___("General|Expected Order Completion Date|content") }}:
                <span>{{ formatDate(modalData.plannedShippingDate) }}</span>
            </div>

            <p v-if="modalData.grossAmount && $page.props.user.show_article_prices && $page.props.user.show_order_view">
                {{ ___("General|Amount|content") }}:
                {{ formatCurrency(modalData.grossAmount) }}
            </p>

            <div
                class="
                block
                md:flex
                items-center
                bg-primary-color
                text-primary-text-color text-sm
                font-bold
                px-4
                py-3
                my-3
                "
                v-if="modalData.status == 'ORDER_ENTRY_IN_PROGRESS'"
            >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
                </svg>
                <p>
                {{ ___("General|NewOrders|content", { team: teamName }) }}
                </p>
            </div>

            <div v-else>
                <a
                v-if="$page.props.user.show_order_view && $page.props.user.show_article_prices"
                :href="'openorderpdf/' + modalData.id"
                target="_blank"
                class="
                inline-block
                mt-2
                bg-primary-color
                text-primary-text-color
                border border-primary-color
                hover:bg-primary-text-color hover:text-primary-color
                font-bold
                uppercase
                text-sm
                py-2
                px-4
                rounded-full
                outline-none
                focus:outline-none
                "
            >
                {{ ___("Pipeline|OrderDetail|content") }}
            </a>
            </div>


          </div>
          <div v-if="salesBillofItemForPipeline!='do_not_show'" class="border-t border-solid border-gray-300 mt-5 pt-3">
            <h4> {{ ___("Shop|Items included|content") }}: -</h4>

            <table 
            class="border-collapse w-full table-fixed">
            <thead>
              <tr>
                <th class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell">
                  {{ ___("Shop|Article name|content") }}
                </th>
                <th class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell">
                  {{ ___("Shop|Article id|content") }}
                </th>
                <th class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell">
                  {{ ___("Shop|Article number|content") }}
                </th>
                <th  class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell">
                  {{ ___("Shop|Quantity|content") }}
                </th>
                 <th v-if="salesBillofItemForPipeline !='show_subitems_without_price'"  class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell">
                  {{ ___("Shop|Total price|content") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-sm lg:text-base shadow-md lg:shadow-none hover:bg-gray-300 bg-white border border-b flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-3 lg:mb-0 cursor-pointer"
              v-for="(salesItem, sl) in modalData.orderItems" :key="sl" v-if="sl > 0">
              <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static">
                <span class="lg:hidden text-gray-600 font-bold capitalize">
                  {{ ___("Shop|Article name|content") }}:
                </span>
                {{ salesItem.title }}
              </td>
              <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static">
                <span class="lg:hidden text-gray-600 font-bold capitalize">
                  {{ ___("Shop|Article id|content") }}:
                </span>
                {{ salesItem.articleId }}
              </td>
              <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static">
                <span class="lg:hidden text-gray-600 font-bold capitalize">
                  {{ ___("Shop|Article number|content") }}:
                </span>
                {{ salesItem.articleNumber }}
              </td>
              <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static">
                <span class="lg:hidden text-gray-600 font-bold capitalize">
                  {{ ___("Shop|Quantity|content") }}:
                </span>
                {{ salesItem.quantity }}
              </td>
              <td v-if="salesBillofItemForPipeline !='show_subitems_without_price'" class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static">
                <span class="lg:hidden text-gray-600 font-bold capitalize">
                  {{ ___("Shop|Total price|content") }}:
                </span>
                {{salesItem.grossAmount}}
              </td>
              </tr>
            </tbody>
            </table>

           </div>

        </div>
  
      </template>

      <template v-slot:footer> </template>
      </Modal>
    </div>
</template>
<script>
import Badge from "../Shared/Badge";
import { FormatCurrency } from "../../mixin/formatCurrency";
import { FormatDate } from "../../mixin/formatDate";
import Modal from "@/Components/Modal";
import { Pipeline } from "../../mixin/pipeline";

export default {
  components: {
    Badge,
    Modal,
  },
  mixins: [FormatCurrency, FormatDate,Pipeline],
  props:{
    salesBillofItemForPipeline:String,
    hideExpectedDates:Boolean
  },
  data() {
    return {
      orderModalShown: false,
    };
 },
};
</script>
